import { AskCareerScoutStarters } from "./AskCareerScoutStarters";
import { Box } from "../../../../../mads";
import { useScrollYPosition } from "../../../../../shared/util/scrollPosition";

import { spacing } from "@indeed/ifl-tokens/react-native";
import React, { useEffect, useState } from "react";
import { StyleSheet } from "react-native";

const SCROLL_THRESHOLD = 1;

export const FloatingAskCareerScoutStarters: React.FC = () => {
  const scrollY = useScrollYPosition();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    scrollY.stopAnimation((value) => {
      if (value >= SCROLL_THRESHOLD) {
        setVisible(true);
      }
    });

    const id = scrollY.addListener(({ value }) => {
      if (value >= SCROLL_THRESHOLD) {
        setVisible(true);
      }
    });
    return () => scrollY.removeListener(id);
  }, [scrollY]);

  if (!visible) {
    return null;
  }

  return (
    <Box sx={styles.floatingBar} pointerEvents="box-none">
      {/* The scroll bucket keeps the static starters — see
          useCareerScoutDynamicConvoStartersEnabled in ./proctor. */}
      <AskCareerScoutStarters />
    </Box>
  );
};

const styles = StyleSheet.create({
  floatingBar: {
    paddingHorizontal: spacing.s4,
    paddingVertical: spacing.s1,
  },
});
